<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="900px" append-to-body :destroy-on-close="true" :before-close="cancel">
    <div class="el-dialog-div">
      <div class="section-card">
        <div class="section-header-bar">
          <div class="section-title"><i class="el-icon-s-order"></i> 申领信息</div>
        </div>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">状态</span>
            <span class="detail-value">
              <div v-if="status === 'DEFEAT'">
                <el-tag type="danger" size="small">已取消</el-tag>
                <span v-if="rejectionReason" style="margin-left: 8px; color: #909399;">{{ rejectionReason }}</span>
              </div>
              <div v-else-if="materialType !== 'DRY_ICE'">
                <el-tag v-if="trackingFlag === 1" type="success" size="small">已邮寄</el-tag>
                <el-tag v-else-if="trackingFlag === 0" type="warning" size="small">待邮寄</el-tag>
                <el-tag v-else type="info" size="small">未知状态</el-tag>
              </div>
              <div v-else>
                <el-tag v-if="arrangeFlag === 1" type="success" size="small">已安排</el-tag>
                <el-tag v-else-if="arrangeFlag === 0" type="warning" size="small">待安排</el-tag>
                <el-tag v-else type="info" size="small">未知状态</el-tag>
              </div>
            </span>
          </div>
          <div class="detail-item">
            <span class="detail-label">创建人</span>
            <span class="detail-value">{{ createBy }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">创建时间</span>
            <span class="detail-value">{{ createTime }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">销售</span>
            <span class="detail-value">{{ salesName }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">收件人</span>
            <span class="detail-value">{{ recipientName }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">收件人电话</span>
            <span class="detail-value">{{ recipientPhone }}</span>
          </div>
          <div class="detail-item full-width">
            <span class="detail-label">收件人地址</span>
            <span class="detail-value">{{ recipientAddress }}</span>
          </div>
          <div class="detail-item" v-if="trackingNumber !== ''">
            <span class="detail-label">快递单号</span>
            <span class="detail-value">{{ trackingNumber }}</span>
          </div>
        </div>
      </div>

      <div class="sub-section" v-if="materialRequestDetailDTOS.length > 0">
        <div class="sub-section-title">
          <span><i class="el-icon-box"></i> 申领物料信息</span>
        </div>
        <div v-for="(material, index) in materialRequestDetailDTOS" :key="index" class="detail-grid" style="margin-bottom: 10px; border: 1px solid #ebeef5; border-radius: 4px;">
          <div class="detail-item">
            <span class="detail-label">物料名称</span>
            <span class="detail-value">{{ material.materialLexiconDTO.materialName }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">数量</span>
            <span class="detail-value">{{ material.number }}</span>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" v-if="status === 'DEFEAT'" type="warning" class="title" @click="handleMail">重新提交</el-button>
      <el-button size="small" type="primary" class="title" @click="cancel">确定</el-button>
    </div>
    <add-edit-request v-if="showAddEditDialog" :show-dialog="showAddEditDialog" select-type="edit" :select-detail="editDetail" @submit="closeAddEditDialog"></add-edit-request>
  </el-dialog>
</template>

<script>

import ExFoldCellToo from "@/components/ExFoldCellToo.vue";
import AddEditRequest from "@/components/material/Request/AddEditRequest.vue";

export default {
  name: "RequestDetails",
  components: {AddEditRequest, ExFoldCellToo},
  props:['showDialog','selectDetail','auditDetail'],
  data(){
    return{
      showAddEditDialog:false,
      editDetail:{},

      data:{name:'materialLexiconDTO.materialName',value:'number'},
      title:'查看申领信息详情',
      id:'',
      status: '',
      rejectionReason: '',
      operator: '',
      auditTime: '',
      salesName:'',
      recipientName: '',
      createBy:'',
      createTime:'',
      trackingNumber:'',
      materialRequestDetailDTOS:[],
      recipientAddress:'',
      recipientPhone:'',
      trackingFlag: '',
      arrangeFlag: '',
      materialType: ''
    }
  },
  watch:{
    auditDetail: {
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          if(newVal.data.trackingNumber){
            this.trackingNumber = newVal.data.trackingNumber
          }
          this.materialType = newVal.data.materialType
          this.createBy = newVal.data.createBy
          this.createTime = newVal.data.createTime
          this.recipientPhone = newVal.data.recipientPhone
          this.recipientAddress = newVal.data.recipientAddress
          if(newVal.data.materialRequestDetailDTOS){
            this.materialRequestDetailDTOS = newVal.data.materialRequestDetailDTOS
          }
          if(newVal.data.sales.name){
            this.salesName = newVal.data.sales.name
          }
          this.recipientName = newVal.data.recipientName
          this.trackingFlag = newVal.data.trackingFlag
          this.arrangeFlag = newVal.data.arrangeFlag
        }
      },
      immediate:true
    },
    selectDetail:{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.id = newVal.id
          if(newVal.trackingNumber){
            this.trackingNumber = newVal.trackingNumber
          }
          if(newVal.materialRequestDetailDTOS){
            this.materialRequestDetailDTOS = newVal.materialRequestDetailDTOS
          }
          if(newVal.sales){
            this.salesName = newVal.sales.name
          }
          this.status = newVal.status
          this.rejectionReason = newVal.rejectionReason
          this.materialType = newVal.materialType
          this.recipientName = newVal.recipientName
          this.recipientAddress = newVal.recipientAddress
          this.recipientPhone = newVal.recipientPhone
          this.createBy = newVal.createBy
          this.createTime = newVal.createTime
          this.trackingFlag = newVal.trackingFlag
          this.arrangeFlag = newVal.arrangeFlag
        }
      },
      immediate:true
    },
  },
  methods:{
    cancel(){
      this.$emit('submit','cancel')
    },
    closeAddEditDialog(type) {
      this.showAddEditDialog = false
      this.editDetail = {}
      if (type === 'confirm') {
        this.$store.commit('right/setChangeRed',true)
        this.$emit('submit','confirm')
      }
    },
    handleMail(){
      this.editDetail = JSON.parse(JSON.stringify(this.selectDetail))
      this.showAddEditDialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/detail.css";

.el-dialog-div {
  max-height: 90vh;
  overflow-y: auto;
  padding-right: 5px;
}
</style>
